import "./Shop.module.css";
import Header from "@/reusable_sections/Header";
import ShopHero from "./sections/ShopHero";
import Listings from "./sections/Listings";
import Footer from "@/reusable_sections/Footer";
export default function ShopPage() {
  return <div>
      <Header />
      <ShopHero />
      <Listings />
      <Footer />
    </div>;
}